import Framework7 from "framework7";

export default {
  subscribe(name, email) {
    Framework7.request.promise.get(`/.netlify/functions/subscribe?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`).catch((err) => { console.log(err)} );
  }
};